const methodsWithoutBody = new Set(["GET", "HEAD"])

function serializeRequestBody(body, bodyType) {
  if (bodyType === "json") {
    return JSON.stringify(body)
  }
  if (body instanceof URLSearchParams) {
    return body
  }
  return new URLSearchParams(body)
}

export async function parseResponseData(response) {
  const responseText = await response.text()
  if (!responseText) {
    return undefined
  }
  try {
    return JSON.parse(responseText)
  } catch (_error) {
    return responseText
  }
}

export function buildRequestOptions({
  method,
  headers,
  body,
  bodyType,
  ...rest
}) {
  const normalizedMethod = method ?? "GET"
  const requestOptions = {
    method: normalizedMethod,
    headers,
    ...rest,
  }
  if (
    body !== undefined &&
    body !== null &&
    !methodsWithoutBody.has(normalizedMethod.toUpperCase())
  ) {
    requestOptions.body = serializeRequestBody(body, bodyType)
  }
  return requestOptions
}
